module.exports = __webpack_public_path__ + "img/GitGitHub.e1e093b6.webp";